"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Occupancy$ = exports.Occupancy$outboundSchema = exports.Occupancy$inboundSchema = void 0;
exports.occupancyToJSON = occupancyToJSON;
exports.occupancyFromJSON = occupancyFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const occupancytypes_js_1 = require("./occupancytypes.js");
/** @internal */
exports.Occupancy$inboundSchema = z.object({
    occupancy_type: occupancytypes_js_1.OccupancyTypes$inboundSchema,
    owner_occupied: z.boolean(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "occupancy_type": "occupancyType",
        "owner_occupied": "ownerOccupied",
    });
});
/** @internal */
exports.Occupancy$outboundSchema = z.object({
    occupancyType: occupancytypes_js_1.OccupancyTypes$outboundSchema,
    ownerOccupied: z.boolean(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        occupancyType: "occupancy_type",
        ownerOccupied: "owner_occupied",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Occupancy$;
(function (Occupancy$) {
    /** @deprecated use `Occupancy$inboundSchema` instead. */
    Occupancy$.inboundSchema = exports.Occupancy$inboundSchema;
    /** @deprecated use `Occupancy$outboundSchema` instead. */
    Occupancy$.outboundSchema = exports.Occupancy$outboundSchema;
})(Occupancy$ || (exports.Occupancy$ = Occupancy$ = {}));
function occupancyToJSON(occupancy) {
    return JSON.stringify(exports.Occupancy$outboundSchema.parse(occupancy));
}
function occupancyFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Occupancy$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Occupancy' from JSON`);
}
//# sourceMappingURL=occupancy.js.map